<template>
  <div class="navbar">
    <div class="navbar__container container">
      <router-link class="navbar__logo" :to="{name:'home'}">
        <img src="../../assets/logo.svg" alt="Logo image" width="50" height="59">
      </router-link>
      <div class="navbar__list ">
        <ul>
          <li v-for="(item, key) in items" :key="key" :class="{'dropdown': item.children}">
            <template v-if="item.children">
              <a class="dropdown-toggle" :class="{'show': openDropdown === key}" href="#" role="button" :aria-expanded="openDropdown === key" @click.prevent="toggleDropdown(key)">
                {{ item.title }}
              </a>
              <ul class="dropdown-menu" :class="{'show': openDropdown === key}" v-show="openDropdown === key">
                <li v-for="(child, childKey) in item.children" :key="childKey">
                  <router-link class="dropdown-item" :to="resolveLink(child)" @click="openDropdown = null">{{ child.title }}</router-link>
                </li>
              </ul>
            </template>
            <a v-else-if="item.external" :href="item.href" @click="openDropdown = null">{{ item.title }}</a>
            <router-link
                v-else
                :to="resolveLink(item)"
                v-scroll-to="resolveScrollPosition(item)"
                @click="openDropdown = null">{{ item.title }}</router-link>
          </li>

        </ul>
      </div>
      <transition name="expand">
        <div class="navbar__mobilelist " v-show="is_mobile_open">
          <ul>
            <li v-for="(item, key) in items" :key="key" :class="{'has-children': item.children}">
              <template v-if="item.children">
                <span class="mobile-group-title">{{ item.title }}</span>
                <ul class="mobile-children">
                  <li v-for="(child, childKey) in item.children" :key="childKey">
                    <router-link :to="resolveLink(child)" @click="is_mobile_open = false">{{ child.title }}</router-link>
                  </li>
                </ul>
              </template>
              <a v-else-if="item.external" :href="item.href">{{ item.title }}</a>
              <router-link
                  v-else
                  :to="resolveLink(item)"
                  v-scroll-to="resolveScrollPosition(item)"
                  @click="is_mobile_open = false">{{ item.title }}</router-link>
            </li>
          </ul>
        </div>
      </transition>
      <div class="navbar__icon " :class="is_mobile_open ? '' : 'active' " @click="toggleMobileNav">
        <span></span><span></span><span></span><span></span>
      </div>
      <div class="navbar__action">
        <a class="btn btn-secondary btn-small btn-outlined" href="https://scheduler.zoom.us/tom-belote/shelfset" target="_blank">
          <span class="d-flex align-items-center justify-content-center h-100">Contact</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {get} from "lodash";
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      is_mobile_open: false,
      openDropdown: null
    }
  },
  mounted(){
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount(){
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    $route(){
      this.is_mobile_open = false;
      this.openDropdown = null;
    }
  },
  methods: {
    resolveLink(item) {
      return get(item, 'to', {path: '/'})
    },
    resolveScrollPosition(item) {
      return get(item, 'scrollto', '#app');
    },
    toggleDropdown(key) {
      this.openDropdown = this.openDropdown === key ? null : key;
    },
    handleClickOutside(event) {
      const navbarList = this.$el.querySelector('.navbar__list');
      if (navbarList && !navbarList.contains(event.target)) {
        this.openDropdown = null;
      }
    },
    toggleMobileNav(){
      this.is_mobile_open = !this.is_mobile_open;
      this.toggleBodyClass();
    },
    toggleBodyClass(){
      if(this.is_mobile_open){
        document.body.classList.add('nav-open');
      } else {
        document.body.classList.remove('nav-open');
      }
    }
  }
}
</script>